import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { ThemeProvider } from '@tl4k/frontend-shared'
import { TL4KAppShell } from '@tl4k/admin-ui'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider ageGroup="7-10">
      <TL4KAppShell appLabel="AR Editor">
        <App />
      </TL4KAppShell>
    </ThemeProvider>
  </React.StrictMode>,
)
